module.exports = __webpack_public_path__ + "img/is_overed.9b17b902.png";